import type { StaffOrderDetail } from "@/api/staff";

const WEEK_DAYS = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

/** 从 book_time_desc 如 "2026-05-14 12:00" 中提取星期几 */
function getWeekDay(bookTimeDesc?: string): string {
  if (!bookTimeDesc) return "";
  const dateStr = bookTimeDesc.split(" ")[0];
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";
  return WEEK_DAYS[d.getDay()];
}

interface Props {
  orderInfo: StaffOrderDetail;
  onCall: () => void;
}

export function ServiceInfoCard({ orderInfo, onCall }: Props) {
  const coverImg = (orderInfo as any)?.image || (orderInfo as any)?.thumb || "";
  // 后端已脱敏，直接使用；未脱敏时才前端处理
  const displayPhone =
    orderInfo.link_phone && !orderInfo.link_phone.includes("*")
      ? orderInfo.link_phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
      : orderInfo.link_phone;

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
      {/* 封面大图 */}
      {coverImg && (
        <div className="w-full h-40 overflow-hidden">
          <img src={coverImg} alt="" className="w-full h-full object-cover" />
        </div>
      )}

      {/* 标签行 */}
      <div className="px-4 pt-4 pb-2 flex items-center gap-2 flex-wrap">
        <span className="text-sm text-gray-800">{orderInfo.service_min ?? orderInfo.num}{orderInfo.unit_name}</span>
        <span className="text-gray-300">|</span>
        <span className="text-sm text-gray-600">{orderInfo.travel_mode_title || orderInfo.item_name}</span>
        <span className="text-gray-300">|</span>
        <span className="text-sm text-gray-500">
          {orderInfo.accept_order_type === 1 ? "小时单" : orderInfo.accept_order_type === 2 ? "日单" : "半日游"}
        </span>
      </div>

      {/* 标题 */}
      <div className="px-4 pb-3">
        <h3 className="text-base font-bold text-gray-900">{orderInfo.item_name}</h3>
      </div>

      {/* 两列信息网格 */}
      <div className="px-4 pb-4 grid grid-cols-2 gap-y-3 gap-x-4 text-sm">
        <InfoCell label="" value={orderInfo.link_name} />
        <InfoCell label="" value={displayPhone || "-"} />
        <InfoCell label={`预约时间（${getWeekDay(orderInfo.book_time_desc)}）`} value={`${orderInfo.service_min ?? orderInfo.num}${orderInfo.unit_name}`} />
        <InfoCell label="" value={orderInfo.book_time_desc?.split(" ")?.[1] || "-"} />
        <InfoCell label={orderInfo.book_time_desc?.split(" ")?.[0] || ""} value="" />
        <InfoCell label="所需区域" value={orderInfo.address || "-"} />
        <InfoCell label="用户姓名" value={(orderInfo.userInfo as any)?.nickname || orderInfo.link_name || "-"} />
        <InfoCell label="用户人数" value={`${orderInfo.num}人`} />
      </div>

      {/* 备注 */}
      <div className="px-4 pb-4 pt-1 border-t border-gray-50">
        <div className="flex items-start text-sm">
          <span className="text-gray-400 shrink-0 mr-2">备注：</span>
          <span className="text-gray-600">{orderInfo.remark || "无"}</span>
        </div>
      </div>
    </div>
  );
}

function InfoCell({ label, value }: { label?: string; value?: string | number }) {
  if (!label && !value) return null;
  return (
    <div className="flex flex-col">
      {label && <span className="text-xs text-gray-400 mb-0.5">{label}</span>}
      <span className="text-sm text-gray-800 truncate">{value || "-"}</span>
    </div>
  );
}
